export const POSTHOG_PROJECT_TOKEN = process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;
export const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST ?? "https://us.i.posthog.com";

export const isPostHogEnabled = (): boolean => {
  if (!POSTHOG_PROJECT_TOKEN) {
    return false;
  }

  return (
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_ENABLE_ANALYTICS_IN_DEV === "true"
  );
};
